module.exports = "/assets/data/1ea79362e7d7e54e1dadb43a24351c1b-SE9.data.json";